import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Formik } from "formik";
import { set, values, _ } from "lodash";

// component
import { COLOR_WHITE, LINEAR_GRADIENT_BG, USER_KEY } from "../../../const";
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
  successUpdateSwal,
  warningSwal,
} from "../../../helper/sweetalert";
import CustomButton from "../../../components/CustomButton";
import AnimationLoading from "../../../components/Animationloading";
import EmptyComponent from "../../../components/EmptyComponent";
import PaginationHelper from "../../../components/PaginationHelper";

// apollo
import { GET_CATEGORYS } from "../../../apollo/category/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  UPDATE_CATEGORY,
} from "../../../apollo/category/Mutation";

// icon 
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineBorderColor } from "react-icons/md";

// react bootrap
import { Form, Modal, Spinner, Table, Button, Row, Col } from "react-bootstrap";
import ComfirmModal from "../../../components/ComfirmModal";
import { ReactIcons } from "../../../icons";

function ProductType() {
  const history = useHistory();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [productType, setProductType] = useState();
  const [categoryTotal, setCategoryTotal] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const [searchCategory, setSearchCategory] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});
  const [showAddProduct, setShowAddProduct] = useState({
    isOpen: false,
    data: null,
    editMode: false
  });
  const [isMoreFields, setIsMoreFields] = useState(false)

  // ==========> useLaztQuery And useMutation <==========

  const [LoadProductType, { data: GetProductTypeData, loading }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "cache-and-network" }
  );

  const [createCategory, { loading: loadingCreate }] = useMutation(CREATE_CATEGORY);
  const [deleteCategory, { loading: loadingDelete }] = useMutation(DELETE_CATEGORY);
  const [updateCategory, { loading: loadingUpdate }] = useMutation(UPDATE_CATEGORY);

  // ==========> useEffect <==========

  useEffect(() => {
    onNextOrBackPage();
  }, [_skip, pageNumber]);

  useEffect(() => {
    if (GetProductTypeData) {
      setProductType(GetProductTypeData?.categories?.data);
      setCategoryTotal(GetProductTypeData?.categories?.total);
    }
  }, [GetProductTypeData]);

  useEffect(() => {
    _filter();
  }, [searchCategory, shopId]);

  // ==========> Fuction <==========

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
        orderBy: "createdAt_DESC",
      };

      // TODO: check if search text is not empty
      //   if (!_.isEmpty(searchCategory)) { _where = { ..._where, title: searchCategory, } }
      if (searchCategory !== "") {
        _where = {
          ..._where,
          name: searchCategory,
        };
      }

      // TODO: Get all product

      await LoadProductType({
        variables: {
          limit: 50,
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // ==========> fuction delete <==========
  const handleShowDelete = (id, name) => {
    setDelete({ name, id });
    setShowDelete(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteCategory({
        variables: {
          where: {
            id: Delete.id,
          },
        },
      });

      _filter();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  // ==========> fuction pagination  <==========
  const onNextOrBackPage = async () => {
    try {
      const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data
        ?.shop?.id;

      await LoadProductType({
        variables: {
          where: {
            isDeleted: false,
            shop: shopId,
          },
          skip: (_skip - 1) * _limit,
          limit: _limit,
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  // <=============== create Category =================>
  const handleCreateCategory = async (values) => {
    // get shop data from localstrage
    let localData = JSON.parse(localStorage.getItem('SHOP_DATA'));
    if (!values.name) {
      warningSwal("ກະລຸນາເພີ່ມຊື່ປະເພດສິນຄ້າ...");
      return;
    }
    try {
      if (loadingCreate) return;
      await createCategory({
        variables: {
          data: {
            ...values,
            shop: localData?.id,
          },
        },
      });
      _filter();
      successSwal("ເພີ່ມສຳເລັດ");
      setShowAddProduct({
        isOpen: false,
        data: null,
        editMode: false
      });
    } catch (err) {
      warningSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      console.log("error creating todo:", err);
    }
  };

  // <============== Update Categery =================>

  const handleUpdateCategory = async (values) => {
    try {
      // console.log({ editData })
      await updateCategory({
        variables: {
          where: {
            id: showAddProduct?.data?.id,
          },
          data: values,
        },
      });

      setShowAddProduct({
        isOpen: false,
        data: null,
        editMode: false
      });
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      _filter();
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      console.log("error creating todo:", err);
    }
  };

  // <============== Edit box =================>
  const onEditData = async (data, index) => {
    setIsEdit(true);
    setEditIndex(index);
    setEditData(data);
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  return (
    <React.Fragment>
      <div style={{ padding: 15, background: COLOR_WHITE, minHeight: '100vh' }}>
        <div>
          <h3>
            ປະເພດ ({categoryTotal})
          </h3>
          <p>ລາຍການປະເພດສິນຄ້າ</p>
        </div>

        {/* table */}
        <div
          style={{
            width: "100%",
            marginTop: "2em",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Form.Group controlId="exampleForm.ControlInput1">
            <Form.Label>ປະເພດ</Form.Label>
            <Form.Control
              placeholder="ຄົ້ນຫາ..."
              aria-describedby="basic-addon2"
              onChange={(e) => {
                setSearchCategory(e.target.value);
              }}
              value={searchCategory}
              style={{
                maxWidth: '60em'
              }}
            />
          </Form.Group>

          <CustomButton
            onClick={() => setShowAddProduct({
              isOpen: true,
              data: null,
              editMode: false
            })}
            width="125px"
            height="46px"
            title="ເພີ່ມ"
            icon={<ReactIcons.MdAdd style={{ fontSize: 24 }} />}
            borderRadius="8px"
          />
        </div>
        {productType?.length > 0 ? (
          <Table
            responsive
            style={{
              marginTop: "20px",
              borderCollapse: "collapse",
              width: "100% ",
            }}>
            <thead>
              <tr>
                <th>No</th>
                <th>ຊື່ປະເພດ</th>
                <th>ບໍລິສັດ</th>
                <th>ເບີໂທ</th>
                <th>ອິເມວ</th>
                <th>ທີ່ຢູ່</th>
                <th>ວັນທີ,ເດືອນ,ປີ</th>
                <th style={{ textAlign: 'right' }}>ຈັດການ</th>
              </tr>
            </thead>
            {loading ? (
              <AnimationLoading />
            ) : (
              <tbody>
                {productType?.map((productType, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td style={{ paddingTop: "1rem" }}>
                      {productType?.name}
                    </td>
                    <td>{productType?.companyOption ?? "-"}</td>
                    <td>{productType?.phoneOption ?? "-"}</td>
                    <td>{productType?.emailOption ?? "-"}</td>
                    <td>{productType?.addressOption ?? "-"}</td>
                    <td style={{ paddingTop: "1rem" }}>
                      {moment(productType?.createdAt).format("DD/MM/YYYY")}
                    </td>
                    <td align="right" >
                      <div
                        style={{ display: "flex", alignItems: "center", justifyContent: 'end' }}>
                        <Button
                          variant="outline-primary"
                          onClick={() => setShowAddProduct({
                            isOpen: true,
                            data: productType,
                            editMode: true
                          })}
                        ><ReactIcons.MdEdit style={{ fontSize: 24 }} /> </Button>
                        &ensp;

                        <Button
                          variant="outline-danger"
                          onClick={() =>
                            handleShowDelete(
                              productType?.id,
                              productType?.name
                            )
                          }
                        ><ReactIcons.MdDeleteOutline style={{ fontSize: 24 }} /> </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        ) : (
          <div>
            {productType?.length <= 0 && (
              <div
                style={{
                  fontSize: "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#6B7280",
                  fontWeight: "400",
                }}>
                <EmptyComponent />
                <p>ຍັງບໍ່ມີປະເພດສິນຄ້າກະລຸນາໄປເພີ່ມປະເພດສິນຄ້າກ່ອນ !!!</p>
              </div>
            )}
          </div>
        )}

        {categoryTotal > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}>

            <div>{Pagination_helper(categoryTotal, "", ``)}</div>
            <div />
          </div>
        ) : (
          ""
        )}

        {/* end table */}
      </div>





      {/* Confirm Delete */}
      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={
          _confirmeDelete
        }
        title="ແຈ້ງເຕືອນ"
        text={
          `ທ່ານຕອ້ງການລົບຂໍ້ມູນ` + ` ${Delete?.name}` + ` ນີ້ເເທ້ບໍ່!`
        }
      />

      {/* create category */}

      <Modal show={showAddProduct.isOpen} onHide={() => setShowAddProduct({
        isOpen: false,
        data: null,
        editMode: false
      })}>
        <Modal.Header closeButton>
          <Modal.Title>{showAddProduct?.editMode ? "ແກ້ໄຂປະເພດສິນຄ້າ" : "ເພີ່ມປະເພດສິນຄ້າ"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            name: showAddProduct?.data?.name ?? "",
            companyOption: showAddProduct?.data?.companyOption ?? "",
            phoneOption: showAddProduct?.data?.phoneOption ?? "",
            emailOption: showAddProduct?.data?.emailOption ?? "",
            addressOption: showAddProduct?.data?.addressOption ?? "",
            websiteOption: showAddProduct?.data?.websiteOption ?? "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            showAddProduct?.editMode ? handleUpdateCategory(values) : handleCreateCategory(values);
          }}>
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <Modal.Body className="p-4">
                <Form.Group className="mb-4">
                  <Form.Label>ຊື່ປະເພດ</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    placeholder="ປ້ອນ..."
                  />
                </Form.Group>
                <Button className="w-100" variant={isMoreFields ? "secondary" : "outline-secondary"} onClick={() => setIsMoreFields(!isMoreFields)}>ຂໍ້ມູນເພິ່ມເຕີມ</Button>
                <br />
                <br />
                {isMoreFields && (
                  <div>
                    <Form.Group className="mb-4">
                      <Form.Label>ບໍລິສັດ (ບໍ່ບັງຄົບ)</Form.Label>
                      <Form.Control
                        type="text"
                        name="companyOption"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.companyOption}
                        placeholder="ປ້ອນ..."
                      />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group className="mb-4">
                          <Form.Label>ເບີໂທ (ບໍ່ບັງຄົບ)</Form.Label>
                          <Form.Control
                            type="text"
                            name="phoneOption"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phoneOption}
                            placeholder="ປ້ອນ..."
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-4">
                          <Form.Label>ອິເມວ (ບໍ່ບັງຄົບ)</Form.Label>
                          <Form.Control
                            type="text"
                            name="emailOption"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.emailOption}
                            placeholder="ປ້ອນ..."
                          />
                        </Form.Group>
                      </Col>
                    </Row>


                    <Form.Group className="mb-4">
                      <Form.Label>ທີ່ຢູ່: (ບໍ່ບັງຄົບ)</Form.Label>
                      <Form.Control
                        type="text"
                        name="addressOption"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.addressOption}
                        placeholder="ປ້ອນ..."
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>ເວບໄຊ (ບໍ່ບັງຄົບ)</Form.Label>
                      <Form.Control
                        type="text"
                        name="websiteOption"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.websiteOption}
                        placeholder="ປ້ອນ..."
                      />
                    </Form.Group>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => setShowAddProduct({
                  isOpen: false,
                  data: null,
                  editMode: false
                })} variant="outline-secondary">ຍົກເລີກ</Button>
                <Button onClick={() => handleSubmit()} variant="light" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }}>
                  {(loadingUpdate || loadingCreate) ? <><Spinner animation="border" size="sm" /> ກຳລັງບັນທຶກ...</> : "ຢືນຢັນ"}
                </Button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>
    </React.Fragment >
  );
}

export default ProductType;
